import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import _ from 'lodash'
import { Segment, Table, Statistic, Select } from 'semantic-ui-react'
import styled from 'styled-components'

import HasuraOrderActions from '../../reducers/hasuraOrderReducer'
import DownloadButton from './components/DownloadSheetButton'
import DateRangeField from './components/DateRangeField'
import timeFromNow from './components/TimeFromNow'
import utils from '../../utils'
import { Grid } from 'semantic-ui-react'

const Price = styled.div`
  font-weight: bold;
  color: #20ba45;
`

const headers = [
  'No',
  'Key',
  'Customer Name',
  'Order Count',
  'Order At',
  'Merchant',
  'Region',
  'Reward Type',
  'Redemption Amount',
  'Code',
  'Instant Discount',
  'Company Discount',
  'Merchant Discount',
  'Delivery Discount',
]

class PromoCodeReport extends React.PureComponent {
  state = {
    startFrom: Number(
      moment()
        .startOf('month')
        .format('x')
    ),
    endAt: Number(
      moment()
        .endOf('month')
        .format('x')
    ),
    codes: [],
    merchantNames: [],
    rewardTypes: [],
    discountType: 'all',
  }

  onFieldChange = (field, value) => {
    this.setState({ [field]: value })
  }

  getLoyaltyVoucherStats = voucher => {
    if (!voucher) return { loyalty_voucher_type: '', loyalty_voucher_amount: '' }

    const {
      voucher: { metadata, is_referral_code, type },
      order: { discount_amount = '' },
    } = voucher

    const isReward = _.get(metadata, 'rank', false)
    let loyalty_voucher_type = ''

    if (is_referral_code) {
      loyalty_voucher_type = 'referral'
    } else if (isReward) {
      loyalty_voucher_type = 'reward'
    } else if (type === 'GIFT_VOUCHER') {
      loyalty_voucher_type = 'gift_card'
    }
    const discountAmountFormatted = discount_amount / 100
    return { loyalty_voucher_type, loyalty_voucher_amount: discountAmountFormatted }
  }

  validateSearchByDate = () => {
    const { startFrom, endAt } = this.state

    if (startFrom > endAt) {
      return false
    }

    return true
  }

  getOrderByDate = () => {
    const { getPromoCodeOrders } = this.props
    const { startFrom, endAt } = this.state

    getPromoCodeOrders(startFrom, endAt)
  }

  onSearch = () => {
    const validDate = this.validateSearchByDate()

    if (validDate) {
      this.getOrderByDate()
    } else {
      alert('Date invalid, please check it again')
    }
  }

  renderStatistics = orders => {
    const redemptionCount = orders.length

    // const sumDiscount = _.sumBy(orders, order => order.voucher_discount_amount)
    const statisticObject = orders.reduce(
      (accumulator, order) => {
        const {
          voucher_type,
          voucher_discount_type,
          promotion_cost_sharing,
          delivery_discount,
          voucher_discount_amount,
          promotion_discount = 0,
        } = order
        const { merchant_discount = 0, company_discount = 0 } = promotion_cost_sharing || {}
        if (voucher_type === 'DISCOUNT_VOUCHER') {
          accumulator['discountCount'] += 1
        } else {
          accumulator['giftCount'] += 1
        }
        if (voucher_discount_type === 'PERCENT') {
          accumulator['percentageCount'] += 1
        } else {
          accumulator['amountCount'] += 1
        }
        if (promotion_cost_sharing) {
          accumulator['merchantDiscountCount'] += merchant_discount + promotion_discount
          accumulator['companyDiscountCount'] += company_discount
        }
        accumulator['deliveryDiscountAmount'] += delivery_discount
        accumulator['allDiscountAmount'] += voucher_discount_amount
        return accumulator
      },
      {
        discountCount: 0,
        giftCount: 0,
        percentageCount: 0,
        amountCount: 0,
        allDiscountAmount: 0,
        merchantDiscountCount: 0,
        companyDiscountCount: 0,
        deliveryDiscountAmount: 0,
      }
    )

    const orderItems = [
      {
        key: 'success-orders',
        label: 'Amount',
        value: utils.helpers.convertToCurrency(statisticObject['allDiscountAmount']),
        color: 'green',
      },
      {
        key: 'redemption-count',
        label: 'Redemption',
        value: redemptionCount,
        color: 'green',
      },
      {
        key: 'merchant-discount-amount',
        label: 'Merchant Discount Amount',
        value: utils.helpers.convertToCurrency(statisticObject['merchantDiscountCount']),
        color: 'green',
      },
      {
        key: 'company-discount-amount',
        label: 'Company Discount Amount',
        value: utils.helpers.convertToCurrency(statisticObject['companyDiscountCount']),
        color: 'green',
      },
      {
        key: 'delivery-fee-discount',
        label: 'Delivery Fee Offer',
        value: utils.helpers.convertToCurrency(statisticObject['deliveryDiscountAmount']),
        color: 'green',
      },
    ]

    const voucherStatistic = [
      {
        key: 'voucher-type-gift',
        label: 'Gift Voucher',
        value: statisticObject['giftCount'],
        color: 'olive',
      },
      {
        key: 'voucher-type-discount',
        label: 'Discount Voucher',
        value: statisticObject['discountCount'],
        color: 'teal',
      },
      {
        key: 'discount-type-percent',
        label: 'Percent Type Count',
        value: statisticObject['percentageCount'],
        color: 'olive',
      },
      {
        key: 'discount-type-amount',
        label: 'Amount Type Count',
        value: statisticObject['amountCount'],
        color: 'teal',
      },
    ]

    return (
      <React.Fragment>
        <Grid size="equal">
          <Grid.Column>
            <Segment>
              <Statistic.Group items={orderItems} widths="five" size="small" />
            </Segment>
          </Grid.Column>
        </Grid>
        <Grid size="equal" style={{ marginBottom: 14 }}>
          <Grid.Column>
            <Segment>
              <Statistic.Group items={voucherStatistic} widths="four" size="small" />
            </Segment>
          </Grid.Column>
        </Grid>
      </React.Fragment>
    )
  }

  renderRow = (order, index) => {
    const {
      firebase_key,
      voucher_code,
      promotion_discount = '',
      created_at,
      merchant_name,
      customer_name,
      customer_stats: { order_count },
      promotion_cost_sharing,
      delivery_discount,
      region = 'pnh',
      loyalty_voucher_type,
      loyalty_voucher_amount,
    } = order

    const { company_discount = 0, merchant_discount = 0 } = promotion_cost_sharing || {}

    return (
      <Table.Row key={firebase_key}>
        <Table.Cell textAlign="center">{index + 1}</Table.Cell>
        <Table.Cell textAlign="center">{firebase_key}</Table.Cell>
        <Table.Cell textAlign="center">{customer_name}</Table.Cell>
        <Table.Cell textAlign="center">{order_count}</Table.Cell>
        <Table.Cell textAlign="center">{timeFromNow(created_at)}</Table.Cell>
        <Table.Cell textAlign="center">{merchant_name}</Table.Cell>
        <Table.Cell textAlign="center">{region}</Table.Cell>
        <Table.Cell textAlign="center">{loyalty_voucher_type}</Table.Cell>
        <Table.Cell textAlign="center">
          <Price>{loyalty_voucher_amount ? `$ ${loyalty_voucher_amount}` : ''}</Price>
        </Table.Cell>
        <Table.Cell textAlign="center">{voucher_code}</Table.Cell>
        <Table.Cell textAlign="center">
          <Price>{promotion_discount ? `$ ${promotion_discount}` : ''}</Price>
        </Table.Cell>
        <Table.Cell textAlign="center">
          <Price>{company_discount ? `$ ${company_discount}` : ``}</Price>
        </Table.Cell>
        <Table.Cell textAlign="center">
          <Price>
            {!_.isEmpty(promotion_cost_sharing)
              ? merchant_discount
                ? `$ ${merchant_discount}`
                : ``
              : promotion_discount
              ? `$ ${promotion_discount}`
              : ''}
          </Price>
        </Table.Cell>
        <Table.Cell textAlign="center">
          <Price>{delivery_discount ? `$ ${delivery_discount}` : ``}</Price>
        </Table.Cell>
      </Table.Row>
    )
  }

  renderNoDataRow = () => {
    const { loading } = this.props
    return (
      <Table.Row>
        <Table.Cell colSpan={14} textAlign="center">
          {loading ? 'Loading' : 'No Data available'}
        </Table.Cell>
      </Table.Row>
    )
  }

  filterOrder = orders => {
    const { codes, merchantNames, rewardTypes, discountType } = this.state
    let filteredOrders = orders

    filteredOrders =
      discountType === 'all'
        ? filteredOrders
        : filteredOrders.filter(order =>
            discountType === 'code' ? order.voucher_code : order.promotion_discount
          )

    filteredOrders =
      codes.length <= 0 ? filteredOrders : filteredOrders.filter(order => codes.includes(order.voucher_code))

    filteredOrders =
      merchantNames.length <= 0
        ? filteredOrders
        : filteredOrders.filter(order => merchantNames.includes(order.merchant_name))

    filteredOrders =
      rewardTypes.length <= 0
        ? filteredOrders
        : filteredOrders.filter(order => rewardTypes.includes(order.loyalty_voucher_type))

    return filteredOrders
  }

  render() {
    const { startFrom, endAt, codes, merchantNames, discountType, rewardTypes } = this.state
    const { orders, loading } = this.props

    const {
      updatedOrders,
      selectableCodes,
      selectableMerchants,
      selectableRewardType,
      orderLength,
    } = this.decorateOrders(orders)

    const filteredOrders = this.filterOrder(updatedOrders)

    const formatedStartFrom = moment(startFrom).format('DD-MM-YYYY')
    const formatedEndAt = moment(endAt).format('DD-MM-YYYY')

    const filename = `promocode-${
      codes.length <= 0 ? 'all' : codes.join('-')
    }-${formatedStartFrom}-${formatedEndAt}`

    // const extraFields = _.chain(filteredOrders)
    //   .groupBy('voucher_code')
    //   .map((orders, code) => [code, orderLength, `$${_.sumBy(orders, 'voucher_discount_amount')}`].join(','))
    //   .value()

    return (
      <Segment style={{ height: '100%', overflow: 'auto' }}>
        <div style={{ padding: '0px 14px' }}>
          <DateRangeField
            loading={loading}
            startFrom={startFrom}
            endAt={endAt}
            onSearch={this.onSearch}
            onFieldChange={this.onFieldChange}
          />
          <div style={{ marginBottom: 15 }} />
          <Select
            search
            label="Discount Type"
            disabled={orderLength < 0}
            options={[
              { text: 'All', value: 'all' },
              { text: 'Code', value: 'code' },
              { text: 'Merchant', value: 'merchant' },
            ]}
            placeholder="Select Discount Type"
            value={discountType}
            onChange={(e, data) => this.setState({ discountType: data.value })}
          />
          <Select
            multiple
            search
            label="Code"
            disabled={orderLength < 0}
            options={selectableCodes}
            placeholder="All Code"
            value={codes}
            onChange={(e, data) => this.setState({ codes: data.value })}
          />
          <Select
            multiple
            search
            label="Merchants"
            disabled={orderLength < 0}
            options={selectableMerchants}
            placeholder="All Merchant"
            value={merchantNames}
            onChange={(e, data) => this.setState({ merchantNames: data.value })}
          />

          <Select
            multiple
            search
            label="Reward Type"
            disabled={orderLength < 0}
            options={selectableRewardType}
            placeholder="All Reward Type"
            value={rewardTypes}
            onChange={(e, data) => this.setState({ rewardTypes: data.value })}
          />
          <div style={{ marginBottom: 15 }} />

          <DownloadButton
            loading={loading}
            orders={filteredOrders.map((order, index) => {
              const {
                firebase_key,
                voucher_code: code,
                promotion_discount = 0,
                created_at,
                merchant_name,
                customer_name,
                customer_stats: { order_count },
                promotion_cost_sharing,
                delivery_discount = 0,
                region = 'pnh',
                voucher,
              } = order
              const { loyalty_voucher_type, loyalty_voucher_amount } = this.getLoyaltyVoucherStats(voucher)
              const { company_discount = 0, merchant_discount = 0 } = promotion_cost_sharing || {}
              return [
                index + 1,
                firebase_key,
                customer_name,
                order_count,
                moment(created_at).format('DD-MM-YYYY HH:MM:SS'),
                merchant_name,
                region,
                loyalty_voucher_type,
                loyalty_voucher_amount,
                code,
                promotion_discount,
                company_discount,
                !_.isEmpty(promotion_cost_sharing) ? merchant_discount : promotion_discount,
                delivery_discount,
              ].join(',')
            })}
            headers={headers}
            filename={filename}
          />
          <div style={{ marginBottom: 15 }} />
          {this.renderStatistics(filteredOrders)}
          <Table>
            <Table.Header>
              <Table.Row>
                {headers.map((header, index) => (
                  <Table.HeaderCell key={index} textAlign="center">
                    {header}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {filteredOrders.length > 0 ? filteredOrders.map(this.renderRow) : this.renderNoDataRow()}
            </Table.Body>
          </Table>
        </div>
      </Segment>
    )
  }

  decorateOrders = orders => {
    const selectableCodes = _.chain(orders)
      .map(ord => ({ text: ord.voucher_code, value: ord.voucher_code }))
      .uniqBy('value')
      .value()
    const selectableMerchants = _.chain(orders)
      .map(ord => ({ text: ord.merchant_name, value: ord.merchant_name }))
      .uniqBy('value')
      .value()

    const updatedOrders = _.map(orders, order => {
      const { loyalty_voucher_type, loyalty_voucher_amount } = this.getLoyaltyVoucherStats(order.voucher)

      return { ...order, loyalty_voucher_amount, loyalty_voucher_type }
    })

    const selectableRewardType = _.chain(updatedOrders)
      .map(ord => ({ text: ord.loyalty_voucher_type, value: ord.loyalty_voucher_type }))
      .uniqBy('value')
      .value()
    return {
      updatedOrders,
      selectableCodes,
      selectableMerchants,
      selectableRewardType,
      orderLength: orders.length,
    }
  }
}

const mapState = ({ hasuraOrders }) => ({
  orders: hasuraOrders.promoCodeOrders,
  loading: hasuraOrders.promoCodeOrderLoading,
})

const mapDispatch = {
  getPromoCodeOrders: HasuraOrderActions.getPromoCodeOrders,
}

export default connect(
  mapState,
  mapDispatch
)(PromoCodeReport)



// WEBPACK FOOTER //
// ./src/containers/reports/discount.js